import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/layout/App'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('../views/home/About.vue')
      },
      {
        path: "/link/request",
        name: "save-link",
        component: () => import("@/views/link/SaveLink")
      },
      {
        path: "/watch",
        name: "video-link",
        component: () => import("@/views/link/WatchVideo")
      },
      {
        path: "/link/request/sent",
        name: "email-sent",
        component: () => import("@/views/link/EmailSent")
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
